import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

import { HpRespPromoModulePromoItemOld } from './HpRespPromoModulePromoItemOld';
import { HpRespModuleContainerOld } from '../HpRespModuleContainerOld/HpRespModuleContainerOld';
import { trackPromoImpressions, trackPromoClick } from './helpers/PromoTrackingOld';
import { SharedInViewport } from '../../sharedComponents/SharedInViewport';

class HpRespPromoModuleSecondaryOldComponent extends Component {
    promoSecondaryModule = get(this.props, 'homepage.promoSecondaryModule');

    handleInitialDisplay = ({ inViewport }) => {
        if (this.promoSecondaryModule && inViewport) {
            const { items } = this.promoSecondaryModule;

            trackPromoImpressions({
                items,
                startingIndex: this.getPromoPrimaryItemsCount(),
            });
        }
    };

    getPromoPrimaryItemsCount() {
        const promoPrimaryItemsCount =
            get(this.props, 'homepage.promoPrimaryModule.totalItemsCount') || 0;

        return promoPrimaryItemsCount;
    }

    render() {
        if (!this.promoSecondaryModule) {
            return null;
        }

        const { items } = this.promoSecondaryModule;

        return (
            <HpRespModuleContainerOld addTopGap>
                <SharedInViewport stopWhenInViewport onInViewportChange={this.handleInitialDisplay}>
                    <div className="rowFlex">
                        {items.map((promotion, index) => (
                            <HpRespPromoModulePromoItemOld
                                key={promotion.cmsId}
                                promotion={promotion}
                                className={items.length === 1 ? 'colXs12' : 'colLg6 colXs12'}
                                onClick={() =>
                                    trackPromoClick({
                                        item: promotion,
                                        index: index + this.getPromoPrimaryItemsCount(),
                                    })
                                }
                            />
                        ))}
                    </div>
                </SharedInViewport>
            </HpRespModuleContainerOld>
        );
    }
}

HpRespPromoModuleSecondaryOldComponent.propTypes = {
    homepage: PropTypes.object.isRequired,
};

export const HpRespPromoModuleSecondaryOld = createFragmentContainer(
    HpRespPromoModuleSecondaryOldComponent,
    {
        homepage: graphql`
            fragment HpRespPromoModuleSecondaryOld_homepage on Homepage {
                promoSecondaryModule: module(type: "promoSecondary") {
                    ... on PromoModule {
                        items {
                            cmsId
                            imageUrl @skip(if: $isMobile)
                            imageCopy
                            cta
                            mobileImageUrl @include(if: $isMobile)
                            linkData {
                                # path is used in PromoTrackingOld.js
                                path
                                ...SeoLink_linkData
                            }
                        }
                    }
                }
                promoPrimaryModule: module(type: "promoPrimary") {
                    ... on PromoModule {
                        totalItemsCount
                    }
                }
            }
        `,
    }
);
